import React, { useContext } from 'react';
import { array, func, object } from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { FiverrContext, I18n } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import { getPackageTypeById, hasRecommendedPackage, isRecommendedPackage } from '../../../utils/packagesUtils';
import { shouldRenderCustomOrder } from '../../../utils/customOrder';
import isInCustomOrderPackageTest from '../../../utils/experiments/customOrderPackage';
import TabContent from '../TabContent';
import CustomOrderTab from '../CustomOrderTab';
import CheckoutFormHOC from '../../shared/CheckoutFormHOC';
import { calcDefaultCheckedId, reportTabClickEvents } from './utils';
import { customOrderPackage, UPPER_PACKAGES } from './config';

import './style.scss';

const TriplePackage = (
    { packageList, onComparePackagesClick, customOrder },
    { requestContext, general, biEvents }
) => {
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    const { ab_tests: abTests, current_user: currentUser, params } = requestContext;
    const tabList = [...packageList];

    const nonDefaultLocale = locale !== DEFAULT_LOCALE;
    const inCustomOrderPackageTest = isInCustomOrderPackageTest(abTests);
    const shouldRenderCustomOrderTab = inCustomOrderPackageTest && shouldRenderCustomOrder({
        customOrder,
        general,
        currentUser,
        inCustomOrderPackageTest
    });

    if (shouldRenderCustomOrderTab) {
        tabList.push(customOrderPackage);
    }

    const defaultCheckedId = calcDefaultCheckedId(packageList, params);
    const { responseTime } = customOrder;
    const className = classnames('packages-tabs', 'triple', {
        'recommended': hasRecommendedPackage(packageList),
        'show-4-tabs': shouldRenderCustomOrderTab
    });

    return (
        <div className={className}>
            {tabList.map(({ id }) => (
                <input key={id} id={`package-tab-${id}`} name="package-tab-group"
                    type="radio" defaultChecked={defaultCheckedId === id}/>
            ))}

            <div className="nav-container">
                {tabList.map(({ id }) => (
                    <label key={id} htmlFor={`package-tab-${id}`}
                        className={classnames({ 'non-default-locale': nonDefaultLocale })}
                        onClick={() => reportTabClickEvents(biEvents, id)}>
                        <I18n k={getPackageTypeById(id)}/>
                    </label>
                ))}
            </div>

            <div className="tabs-content">
                {packageList.map((packageData) => {
                    const { id } = packageData;
                    const className = classnames('content', { 'recommended': isRecommendedPackage(packageData) });

                    return (
                        <CheckoutFormHOC key={id} className={className} selectedPackageId={id} source={UPPER_PACKAGES}>
                            <TabContent id={id} onComparePackagesClick={onComparePackagesClick}/>
                        </CheckoutFormHOC>
                    );
                })}

                {shouldRenderCustomOrderTab &&
                    <CustomOrderTab responseTime={responseTime} customOrder={customOrder}/>
                }
            </div>
        </div>
    );
};

TriplePackage.propTypes = {
    packageList: array,
    onComparePackagesClick: func,
    customOrder: object
};

TriplePackage.contextTypes = {
    requestContext: object,
    general: object,
    biEvents: object
};

const mapStateToProps = ({ packages }, { onComparePackagesClick }) => ({
    packageList: packages.packageList,
    onComparePackagesClick
});

export { TriplePackage };
export default connect(mapStateToProps)(TriplePackage);
